import { Layout, Row, Col, Button, Avatar  } from "antd";
import styled from "styled-components";

const { Header } = Layout;

export const StyledHeader = styled(Header)`
  background-color: #ffffff;
  border-bottom: 1px solid #cfd4d8;
  padding: unset;
  height: unset;
`;

export const StyledHeaderRow = styled(Row)`
  font-size: 24px;
  font-weight: 700;
  color: #49548d;
`;

export const StyledSidebarControlWrapper = styled(Col)`
  display: none;
  padding: 0 12px;
  border-right: 1px solid #cfd4d8;
  @media (max-width: 992px) {
    display: block;
  }
  @media (max-width: 600px) {
    padding: 0px;
  }
`;

export const StyledColumn = styled(Col)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0 12px;
  font-size: 96px;
  text-align: center;
  width: 232px;
  line-height: 1;
  @media (max-width: 992px) {
    width: unset;
  }
`;

export const VersionText = styled.span`
  margin: 2px 0 4px 8px;
  color: #7c7c7c;
  font-size: 0.625rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  line-height: 1.2;
`;

export const StyledSwitchColumn = styled(Col)`
  width: 150px;
  text-align: center;

  .ant-btn {
    border-radius: 24px;
  }
  .ant-btn .ant-typography {
    color: white;
  }

  @media (max-width: 600px) {
    .ant-btn .ant-typography {
      display: none;
    }

    .ant-btn {
      border-radius: 50%;
      padding: 0px 8px 0px 8px;
    }

    width: fit-content;
    margin-right: 8px;
  }
`;

export const StyledButton = styled(Button)`
  background: transparent;
  border: unset;
  &.ant-btn-icon-only.ant-btn-lg > * {
    font-size: 24px;
  }
`;

export const StyledAvatar = styled(Avatar)`
  color: #7bad7e;
  background: #f4f4f4;
`;

export const Username = styled.p`
  margin: 0;
  font-size: 16px;
  line-height: 1.2;
  @media (max-width: 1000px) {
    display: none;
  }
`;

export const SpaceColumn = styled(Col)`
  flex: 1;
`;

export const UserOptionColWrapper = styled(Col)`
  display: flex;
  align-items: center;
  text-align: right;
  padding: 0 12px;
  border-left: 1px solid #cfd4d8;
  @media (max-width: 600px) {
    padding: 0px;
  }
`;

export const UserDetailsWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`

export const UserTextStack = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 5px;
`

export const UserType = styled.div`
    font-size: .7rem;
    text-transform: uppercase;
    line-height: 1.2;
`